import * as yup from 'yup';

const schema = yup.object().shape(
  {
    notes: yup.string().required().label("Notes"),
  },
);

export default schema;
